const getProfilePublicData = user => user?.attributes?.profile?.publicData || {};

export const normalizeBooleanFlag = value => {
  if (value === true || value === 'true' || value === 1 || value === '1') {
    return true;
  }
  if (value === false || value === 'false' || value === 0 || value === '0') {
    return false;
  }
  return null;
};

const normalizeConnectionOverride = value => {
  if (value === null || value === undefined) {
    return null;
  }

  const normalizedValue = normalizeBooleanFlag(value);
  return normalizedValue !== null ? normalizedValue : Boolean(value);
};

export const getPayoutFlowState = (
  user,
  { stripeConnectedOverride = null, paypalConnectedOverride = null } = {}
) => {
  const publicData = getProfilePublicData(user);
  const merchantIdValue = publicData?.merchantId;
  const merchantId =
    typeof merchantIdValue === 'string' ? merchantIdValue.trim() || null : merchantIdValue || null;
  const rawIsStripeConnected = publicData?.isStripeConnected;
  const rawIsPaypalConnected = publicData?.isPaypalConnected;
  const rawSkippedPayoutDetails = publicData?.skippedPayoutDetails;
  const normalizedStripeFlag = normalizeBooleanFlag(rawIsStripeConnected);
  const normalizedPaypalFlag = normalizeBooleanFlag(rawIsPaypalConnected);
  const normalizedSkippedFlag = normalizeBooleanFlag(rawSkippedPayoutDetails);
  const normalizedStripeOverride = normalizeConnectionOverride(stripeConnectedOverride);
  const normalizedPaypalOverride = normalizeConnectionOverride(paypalConnectedOverride);

  const isStripeConnected = normalizedStripeOverride === true || normalizedStripeFlag === true;
  const isPaypalConnected =
    normalizedPaypalOverride === true || normalizedPaypalFlag === true || Boolean(merchantId);
  const hasConnectedPayoutAccount = isStripeConnected || isPaypalConnected;
  const hasPayoutDetailsSkipped = normalizedSkippedFlag === true;
  const hasExplicitNoConnectedPayouts =
    !hasConnectedPayoutAccount &&
    normalizedStripeFlag === false &&
    normalizedPaypalFlag === false &&
    !merchantId;
  const hasAllPayoutFlowFlagsMissing =
    normalizedStripeFlag === null &&
    normalizedPaypalFlag === null &&
    normalizedSkippedFlag === null &&
    !merchantId;
  const canSkipPayoutOnboarding =
    !hasConnectedPayoutAccount && (hasPayoutDetailsSkipped || hasExplicitNoConnectedPayouts);

  // Some legacy providers can still use the wallet flow even if they never completed payout
  // onboarding. A brand-new profile with no payout flags should still be prompted before publish.
  const shouldUseWalletFlow =
    canSkipPayoutOnboarding || (!hasConnectedPayoutAccount && hasAllPayoutFlowFlagsMissing);
  const shouldRequirePayoutOnboarding = !hasConnectedPayoutAccount && !canSkipPayoutOnboarding;

  return {
    rawIsStripeConnected,
    rawIsPaypalConnected,
    rawSkippedPayoutDetails,
    normalizedStripeFlag,
    normalizedPaypalFlag,
    normalizedSkippedFlag,
    merchantId,
    isStripeConnected,
    isPaypalConnected,
    hasConnectedPayoutAccount,
    hasPayoutDetailsSkipped,
    hasExplicitNoConnectedPayouts,
    hasAllPayoutFlowFlagsMissing,
    canSkipPayoutOnboarding,
    shouldUseWalletFlow,
    shouldRequirePayoutOnboarding,
  };
};
